// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1IBko","title":"Images45_title__3G08Z","images":"Images45_images__B_aFT"};